<template>
    <!-- 联系客服组件 -->
    <div>
        <div class="contact-container">
            <div class="btn" @click="showPopup">
                <multi-img name="icon_service" directory="common" class="icon"></multi-img>
                <div class="f14">{{ $t('ContactCustomerService') }}</div>
            </div>
        </div>
        <ServicePopup :show.sync="showPopupStatus" />
    </div>
</template>

<script>
import ServicePopup from '@/components/ServicePopup.vue'
import MultiImg from '@/components/MultiImg.vue'

export default {
    components: {
        ServicePopup,
        MultiImg,
    },
    data() {
        return {
            showPopupStatus: false,
        }
    },
    computed: {},
    mounted() {},
    methods: {
        // 展示弹窗
        showPopup() {
            this.showPopupStatus = !this.showPopupStatus
        },
    },
}
</script>

<style lang="less" scoped>
.contact-container {
    margin-top: 34px;
    margin-bottom: 24px;
    text-align: center;

    .btn {
        display: inline-flex;
        align-items: center;
        padding: 6px 20px;
        background: #fff;
        border-radius: 16px;
    }

    .icon {
        width: 12px;
        height: 12px;
        margin-right: 4px;
    }
}
</style>
